import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
var p1_max = 0; //定义一个默认变量，并赋值为0，用于比较	
$('.section1 ul li h4').each(function() { //遍历相同样式名的元素
    var p1 = $(this).height(); //获取每个元素的高度，（可根据需要使用outerHeight、innerHeight）
    p1_max = p1 > p1_max ? p1 : p1_max; //比较获取的元素高度值和默认变量，如果比0大，则取获取的值，否则取0
});
$('.section1 ul li h4').height(p1_max); //给每一个元素设置相同的高度	


var p2_max = 0; //定义一个默认变量，并赋值为0，用于比较	
$('.section8 ul li .text').each(function() { //遍历相同样式名的元素
    var p2 = $(this).height(); //获取每个元素的高度，（可根据需要使用outerHeight、innerHeight）
    p2_max = p2 > p2_max ? p2 : p2_max; //比较获取的元素高度值和默认变量，如果比0大，则取获取的值，否则取0
    
});
$('.section8 ul li .text').height(p2_max); //给每一个元素设置相同的高度	


var thumbSwiper = new Swiper(".thumbSwiper", {
    slidesPerView: 3,
    spaceBetween: 18, 
    watchSlidesProgress: true,
    slideToClickedSlide: true,
    breakpoints: {
      1280: {  //当屏幕宽度小于等于1280
        slidesPerView: 3,
        spaceBetween: 18, 
      }, 
      768: {  //当屏幕宽度小于等于768
        slidesPerView: 3,
        spaceBetween: 10, 
      },
      320: {  //当屏幕宽度小于等于320 
        slidesPerView: 2,
        spaceBetween: 10, 
      }
    },
});

var mainSwiper  = new Swiper(".mainSwiper", {
    thumbs: {
        swiper: thumbSwiper
    },
    navigation: {
        nextEl: ".section3  .swiper-button-next",
        prevEl: ".section3  .swiper-button-prev",
    },
});


var textSwiper  = new Swiper(".textSwiper", {

});

// 主图控制文案
mainSwiper.controller.control = textSwiper;

// 文案控制主图
textSwiper.controller.control = mainSwiper;


// var swiper = new Swiper(".section4 .mySwiper2", {
//     spaceBetween: 20,
//     slidesPerView: 6, 
//     breakpoints: {
//       1280: {  //当屏幕宽度小于等于1280
//         spaceBetween: 20,
//         slidesPerView: 6, 
//       }, 
//       768: {  //当屏幕宽度小于等于768
//         spaceBetween: 20,
//         slidesPerView: 4, 
//       },
//       320: {  //当屏幕宽度小于等于320 
//         slidesPerView: 3,
//         spaceBetween: 10, 
//       }
//     },
// });
// var swiper2 = new Swiper(".section4 .mySwiper", {
//     thumbs: {
//         swiper: swiper,
//     },
//     navigation: {
//         nextEl: ".section4  .swiper-button-next",
//         prevEl: ".section4  .swiper-button-prev",
//     },
// });

document.querySelectorAll('.section4').forEach((section) => {

  // 缩略图 swiper
  const thumbSwiper = new Swiper(
    section.querySelector('.mySwiper2'),
    {
      spaceBetween: 20,
      slidesPerView: 6,

      breakpoints: {

        1280: {
          spaceBetween: 20,
          slidesPerView: 6,
        },

        768: {
          spaceBetween: 20,
          slidesPerView: 4,
        },

        320: {
          slidesPerView: 3,
          spaceBetween: 10,
        }

      },

      watchSlidesProgress: true,
    }
  )


  // 主图 swiper
  const mainSwiper = new Swiper(
    section.querySelector('.mySwiper'),
    {

      thumbs: {
        swiper: thumbSwiper,
      },

      navigation: {
        nextEl: section.querySelector('.swiper-button-next'),
        prevEl: section.querySelector('.swiper-button-prev'),
      },

    }
  )

})

$(".application-list .content").eq(0).addClass("active");
$(".application-nav ul li").eq(0).addClass("active");
$(".application-nav ul li").hover(function() {
    let index = $(this).index();
    $(this).addClass("active").siblings().removeClass("active");
    $(".application-list .content").eq(index).addClass("active").siblings().removeClass("active");
})

 var swiper = new Swiper('.section7 .swiper', {
    slidesPerView: 2.34,
    spaceBetween: '1.25%',
    centeredSlides: true,
    loop: true,
    navigation: {
        nextEl: ".section7  .swiper-button-next",
        prevEl: ".section7  .swiper-button-prev",
    },
    breakpoints: {
      1280: {  //当屏幕宽度小于等于1280
        slidesPerView: 2.34,
        spaceBetween: '1.25%',
      }, 
      768: {  //当屏幕宽度小于等于768
        slidesPerView: 2.34,
        spaceBetween: '1.25%',
      },
      320: {  //当屏幕宽度小于等于320 
        slidesPerView: 1,
        spaceBetween: 0,
      }
    },
});

$(".section9 ul li").click(function() {
    $(this).toggleClass("active");
    $(this).find(".text").slideToggle();
})